import { __rest } from "tslib";
import { jsx as _jsx } from "react/jsx-runtime";
import classNames from "classnames";
import { Segmented as AntSegmentedControl } from "antd";
import "./SegmentedControl.scss";
import { styleClasses } from "../../helpers";
const CSS_PREFIX = `lav-components-segmented-control`;
export const SegmentedControl = (_a) => {
    var { className = "", size = "medium", radius } = _a, antSegmentedControlProps = __rest(_a, ["className", "size", "radius"]);
    return (_jsx(AntSegmentedControl, Object.assign({ size: size === "medium" ? "middle" : size }, antSegmentedControlProps, { className: classNames(styleClasses(CSS_PREFIX, {
            size,
            radius,
        }), { [className]: !!className }) })));
};
